import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetGeoSuggestFailed, EGetGeoSuggestActionTypes } from './types';

export const getSuggestionsFailed: () => TGetGeoSuggestFailed = actionGenerator<EGetGeoSuggestActionTypes.Failed>(
  EGetGeoSuggestActionTypes.Failed,
);
